<template>
  <div class="setLoginMain">
    <breadcrumb>
        <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path:'/personal/users/home' }">个人中心</el-breadcrumb-item>
          <el-breadcrumb-item>设置登录密码</el-breadcrumb-item>
        </el-breadcrumb>
    </breadcrumb>
    <div class="setLoginBox">
        <el-form :model="ruleForm2"  v-show="revisionBox" :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
            <el-form-item label="新的登录密码：" prop="pass">
              <el-input type="password" v-model="ruleForm2.pass" autocomplete="off" placeholder="请您输入新的登录密码"></el-input>
            </el-form-item>
            <el-form-item label="确认新的登录密码：" prop="checkPass">
              <el-input type="password" v-model="ruleForm2.checkPass" autocomplete="off" placeholder="请您再次输入新的登录密码"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm2')">提交</el-button>
            </el-form-item>
        </el-form>
        <div class="setSuccessd textAign ft16" v-show="!revisionBox">
            <img src="../../../../../assets/images/safety/succeed_icon.png"><br/>
            设置成功
        </div>
    </div>
  </div>
    
</template>
<script>
import BaseApi from "@lib/baseApi.js";
import md5 from "@lib/encryption.js";
import breadcrumb from "@common/Breadcrumb.vue";
import {mapMutations} from "vuex";
export default {
  data(){
      var validatePass = (rule, value, callback) => {
        var pwdReg=/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,18}$/;
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if(!pwdReg.test(value)){
             callback(new Error('密码不符合规范,请输入字母和数字组成的6-18位密码'));
          }else if (this.ruleForm2.checkPass !== '') {
            this.$refs.ruleForm2.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm2.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
    };
    return {
      ruleForm2: {
          pass: '',
          checkPass: '',
        },
        rules2: {
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
        },
        revisionBox:true
    }
  },
  methods:{
    ...mapMutations(['setUpdateUserState']),
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var  queryStr={
              'handleType':'1',
              'pwd':md5.md5(this.ruleForm2.pass)
            }
            console.log(queryStr)
             BaseApi.createRpcToken("/user/v2/setPwd", queryStr,'post').then((data) => {
                        if(data!=undefined){
                          if(data.code=='200'){
                            this.revisionBox=false;
                            this.setUpdateUserState("setLoginPwd")
                          }
                        }
                      }, (data) => {
                        console.log(data);
                }) 
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
  },
  components:{
    breadcrumb
  }
}
</script>
<style lang="scss">
.setLoginMain{
   width:100%;
   height: 100%;
   padding:20px;
  box-sizing: border-box; 
  .setLoginBox{
    position: relative;
    width: 100%;
    height: 100%;
    .el-form{
      position: absolute;
      display: table;
      width:440px;
      height: 228px;
      left:50%;
      top: 50%;
      margin-top:-114px;
      margin-left: -214px; 
      .el-input__inner{
        width:300px;
        height: 30px;
        .el-form-item__label{
          width:126px;
          font-size: 14px;
          color: #969696;
        }
      }
      .el-form-item__content{
        float: left;
        margin:0!important;
        .el-button--primary{
          width:160px;
          height: 36px;
          margin-left:126px;
          background: #AE3D4A;
          border:none;
        }
        .el-button--primary:hover{
          background: #A5303D;
        }
      }
      .el-form-item__label{
        width: 140px!important;
        float: left;
        margin:0;
        font-family: 'PingFangSC-Medium';
        font-size: 14px;
        color: #969696;
        text-align: right;
        padding-right:0;
      }
    }
    .setSuccessd{
          width:100%;
          position: absolute;
          height: 100px;
          top:50%;
          margin-top:-50px;
          text-align: center;
          color: #505050;
          font-family: 'PingFangSC-Medium';
        }
        img{
        margin-bottom:10px;
      }
  }
}

</style>


